










































import {Component, Prop, Vue} from 'vue-property-decorator'
import DialogTitle from "@/components/Dialog/parts/DialogTitle.vue";
import DialogButtons from "@/components/Dialog/parts/DialogButtons.vue";
import DialogOverlay from "@/components/Dialog/parts/DialogOverlay.vue";
import DialogTextField from "@/components/Dialog/parts/DialogTextField.vue";
import DialogWrapper from "@/components/Dialog/parts/DialogWrapper.vue";
import ImageUploader from "@/components/UI/ImageUploader.vue";
import {Util} from "@/_global/utils";
import CategoriesStore from "@/_common/api/store/modules/CategoriesStore";
import NameInputs from "@/components/UI/NameInputs.vue";

@Component({
    components: {
        NameInputs,
        DialogTextField,
        DialogWrapper,
        DialogTitle,
        DialogButtons,
        DialogOverlay,
        ImageUploader,
    },
})
export default class EditCategoryDialog extends Vue {
    @Prop() private categoryId!: number;

    private categoryNames: { [language_code: string]: string } = {};
    private categoryImageUrl: string = "";
    private editCategoryNames: { [language_code: string]: string } = {};

    mounted() {
        this.categoryNames = this.category.names || {};
        this.categoryImageUrl = this.category.image_url || "";
    }

    get category(): CMS.Category {
        return CategoriesStore.categoryById[this.categoryId] || {};
    }

    private onChangeName(languageCode: string, name: string): void {
        Vue.set(this.editCategoryNames, languageCode, name);
    }

    private onChangeImage(value: string): void {
        this.categoryImageUrl = value;
    }

    private onDeleteImage(): void {
        this.categoryImageUrl = "";
    }

    get editedCategory(): CMS.Category {
        let category: CMS.Category = Util.deepCopy(this.category);
        category.image_url = this.categoryImageUrl;
        category.names = Util.deepCopy(this.editCategoryNames);
        return category;
    }
}
